import { useState, useEffect, useCallback } from 'react';
import { RolesApi } from '@/api/clients/roles/roles.api';

export const useGetRoles = (initialParams = {}) => {
  const [roles, setRoles] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [params, setParams] = useState({
    status: 'ACTIVE',
    page: 1,
    limit: 50,
    ...initialParams,
  });

  const fetchRoles = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const { data } = await RolesApi.getRoles(params);
      setRoles(data.data);
      setPagination(data.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch roles');
      console.error('Error fetching roles:', err);
    } finally {
      setLoading(false);
    }
  }, [params]);

  useEffect(() => {
    setParams((prev) => ({
      ...prev,
      organization_id: initialParams.organization_id || undefined,
    }));
  }, [initialParams.organization_id]);

  useEffect(() => {
    fetchRoles();
  }, [fetchRoles]);

  const updateParams = (newParams) => {
    setParams((prev) => ({ ...prev, ...newParams }));
  };

  const refresh = () => {
    fetchRoles();
  };

  return {
    roles,
    pagination,
    loading,
    error,
    updateParams,
    refresh,
  };
};
